export default class Preload
{
    constructor(params = '')
    {
        this.view = params.view
        this.$items = params.items
        // Vars
        this.fnComplete = params.onComplete
        // Flags
        this.TOTAL = 0
        this.ADD_LOADED = 0
        // Fns
        this.setup()
    }

    complete()
    {
        if(typeof this.fnComplete === 'function') {
            this.fnComplete()
        }
    }

    setup()
    {
        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            const src = $item.getAttribute('data-img')
            const slug = $item.getAttribute('data-slug')
            const elImg = new Image

            if(src.length > 0) {
                elImg.classList.add('visual')
                elImg.classList.add(`slug-${slug}`)
                elImg.addEventListener('load',()=>{
                    this.view.append(elImg)
                    this.ADD_LOADED++
                    if(this.ADD_LOADED === this.TOTAL) {
                        this.complete()
                    }
                })
                elImg.src = src
                this.TOTAL++
            }
        }
    }

}